import { IBaseOption } from '~/utils/interface/common';
import { IMaterial } from '~/utils/interface/material';

export const mockMaterials: IMaterial[] = [
  {
    id: '1',
    name: 'PEX Pipe',
    partNumber: 'PVC-001',
    price: '15000',
    unit: 'Sq. Ft.',
    quantity: '100',
  },
  {
    id: '2',
    name: 'Copper Fitting',
    partNumber: 'BF-002',
    price: '75000',
    unit: 'Each',
    quantity: '200',
  },
  {
    id: '3',
    name: 'Teflon Tape',
    partNumber: 'ST-003',
    price: '500',
    unit: 'Each',
    quantity: '50',
  },
  {
    id: '4',
    name: 'Submersible Pump',
    partNumber: 'WP-004',
    price: '250000',
    unit: 'Sq. Ft.',
    quantity: '10',
  },
];

export const mockDataMaterialUnit: IBaseOption[] = [
  {
    label: 'Sq. Ft.',
    value: 'SQ_FT',
  },
  {
    label: 'Each',
    value: 'EACH',
  },
];
